"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get_firebase_user_profile = get_firebase_user_profile;
var firestore_1 = require("firebase/firestore");
var firebase_1 = require("../../../utils/firebase");
var AddressLocationHelper_1 = require("../../../helpers/AddressLocationHelper");
function isFirestoreTimestamp(v) {
    return (v &&
        typeof v === "object" &&
        typeof v.seconds === "number" &&
        typeof v.nanoseconds === "number");
}
function isFirestoreGeoPoint(v) {
    return v instanceof firestore_1.GeoPoint;
}
function isLegacyGeoPointMap(v) {
    return (v &&
        typeof v === "object" &&
        !(v instanceof firestore_1.GeoPoint) &&
        typeof v.latitude === "number" &&
        typeof v.longitude === "number");
}
function isDocumentReference(v) {
    return v && typeof v === "object" && v.firestore && v.path;
}
function sanitizeFirestoreData(input) {
    if (input == null)
        return input;
    if (Array.isArray(input))
        return input.map(sanitizeFirestoreData);
    if (isFirestoreTimestamp(input)) {
        // Convert to ISO for readability; could also use millis via input.seconds*1000
        var millis = input.seconds * 1000 + Math.floor(input.nanoseconds / 1e6);
        return new Date(millis).toISOString();
    }
    if (isFirestoreGeoPoint(input)) {
        return input;
    }
    if (isLegacyGeoPointMap(input)) {
        return new firestore_1.GeoPoint(input.latitude, input.longitude);
    }
    if (isDocumentReference(input)) {
        return input.path;
    }
    if (typeof input === "object") {
        var out = {};
        for (var _i = 0, _a = Object.keys(input); _i < _a.length; _i++) {
            var k = _a[_i];
            out[k] = sanitizeFirestoreData(input[k]);
        }
        return out;
    }
    return input;
}
function get_firebase_user_profile(firebaseUid) {
    return __awaiter(this, void 0, void 0, function () {
        var userDocRef, snap, raw, sanitized, homeAddress, profileData, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    if (!firebaseUid) {
                        return [2 /*return*/, { success: false, message: "Missing Firebase UID", content: null }];
                    }
                    userDocRef = (0, firestore_1.doc)(firebase_1.firestore, "users", firebaseUid);
                    return [4 /*yield*/, (0, firestore_1.getDoc)(userDocRef)];
                case 1:
                    snap = _b.sent();
                    if (!snap.exists()) {
                        return [2 /*return*/, {
                                success: false,
                                message: "User profile not found",
                                content: null,
                            }];
                    }
                    raw = snap.data();
                    sanitized = sanitizeFirestoreData(raw);
                    homeAddress = (0, AddressLocationHelper_1.mapToAddress)((_a = sanitized === null || sanitized === void 0 ? void 0 : sanitized.home_address) !== null && _a !== void 0 ? _a : null);
                    profileData = __assign(__assign({}, sanitized), { home_address: homeAddress });
                    // Include the uid (document ID) in the sanitized data for FaceTec enrollment
                    profileData.uid = firebaseUid;
                    return [2 /*return*/, {
                            success: true,
                            message: "OK",
                            content: { raw: raw, sanitized: profileData },
                        }];
                case 2:
                    e_1 = _b.sent();
                    return [2 /*return*/, {
                            success: false,
                            message: (e_1 === null || e_1 === void 0 ? void 0 : e_1.message) || "Failed to fetch profile",
                            content: null,
                        }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
